import { Box, Typography } from '@mui/material'

/** All bars share one scale so widths are comparable across rows */
const MAX_RATE = 80

const RateBar = ({ value }: { value: number | null }) => {
  if (value === null) {
    return (
      <Typography sx={{ fontSize: '11px', fontStyle: 'italic', color: '#9CA0A8' }}>
        entfällt
      </Typography>
    )
  }

  // Label sits inside the bar only when the fill is wide enough for it
  const fillsLabel = value >= 25

  return (
    <Box
      sx={{
        position: 'relative',
        height: '16px',
        borderRadius: '8px',
        backgroundColor: '#F5F5F7',
      }}
    >
      <Box
        sx={{
          width: `${(value / MAX_RATE) * 100}%`,
          height: '100%',
          borderRadius: '8px',
          backgroundColor: '#6A6E78',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          paddingRight: fillsLabel ? '6px' : 0,
        }}
      >
        {fillsLabel && (
          <Typography sx={{ fontSize: '9px', fontWeight: 600, color: '#ffffff' }}>
            {value} %
          </Typography>
        )}
      </Box>
      {!fillsLabel && (
        <Typography
          sx={{
            position: 'absolute',
            left: `${(value / MAX_RATE) * 100}%`,
            top: 0,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '6px',
            fontSize: '9px',
            fontWeight: 600,
            color: '#464A54',
          }}
        >
          {value} %
        </Typography>
      )}
    </Box>
  )
}

export default RateBar
